import SectionTitle from '@/components/feature/SectionTitle';

const stats = [
  { num: '5', label: '条剧情主线' },
  { num: '12+', label: '话分集整理' },
  { num: '6', label: '位主要角色' },
  { num: '8', label: '个常见问题' },
];

export default function Overview() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 md:px-6 lg:grid-cols-2 lg:px-8">
        <div>
          <SectionTitle
            kicker="作品速览"
            title="一句话看懂《泡在我家的辣妹》"
            desc="普通高中生直人一时心软，把无处可去的辣妹澪收留进自己家。在同一屋檐下，两个性格天差地别的人从互相嫌弃开始，在鸡飞狗跳的同居日常里逐渐靠近，也慢慢揭开彼此藏起来的真心与秘密。"
          />
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            它是一部主打“反差萌”的校园恋爱喜剧：元气张扬的辣妹 × 温柔慢热的宅男，配上一群鲜活讨喜的配角，既有笑到停不下来的同居日常，也有藏在细节里的暖心治愈。无论你想快速了解剧情，还是想重温名场面，本站都能帮你理清头绪。
          </p>
          <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg bg-background-100 px-4 py-4 text-center">
                <p className="font-heading text-2xl text-primary-600">{s.num}</p>
                <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="overflow-hidden rounded-lg bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20confident%20gal%20girl%20with%20coral%20pink%20hair%20giving%20a%20playful%20wink%2C%20stylish%20street%20outfit%2C%20warm%20cream%20and%20coral%20background%2C%20clean%20flat%20manga%20art%2C%20high%20detail&width=700&height=520&seq=ov-girl-01&orientation=landscape"
              alt="泡在我家的辣妹女主澪元气俏皮的插画"
              className="h-44 w-full object-cover object-top"
            />
            <div className="p-4">
              <p className="font-heading text-lg text-foreground-900">元气满满的外表</p>
              <p className="mt-1 text-sm text-foreground-600">张扬只是保护色，温柔藏在细节里。</p>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg bg-background-100 sm:mt-8">
            <img
              src="https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20gentle%20kind%20high%20school%20boy%20with%20dark%20hair%20smiling%20softly%2C%20casual%20school%20clothes%2C%20warm%20cream%20and%20coral%20background%2C%20clean%20flat%20manga%20art%2C%20high%20detail&width=700&height=520&seq=ov-boy-02&orientation=landscape"
              alt="泡在我家的辣妹男主直人温柔微笑的插画"
              className="h-44 w-full object-cover object-top"
            />
            <div className="p-4">
              <p className="font-heading text-lg text-foreground-900">外冷内热的温柔</p>
              <p className="mt-1 text-sm text-foreground-600">嘴上嫌麻烦，行动却很诚实。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}